import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyModel } from '../models/company.model';
import { UserModel } from '../models/user.model';
import {ApiResponseModel} from '../../shared/entities/api-response.model';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import {UserService} from '../services/user.service';
import {confirmPasswordValidator} from '../reset-password/reset-password.component';
import { MatSort} from '@angular/material';
import {UserProfileModel} from '../models/user-profile.model';
import {HttpErrorResponse} from '@angular/common/http';
import {ValidationMessageService} from '../../shared/services/validation-message-handle';
import {MatFileUploadComponent} from '@webacad/ng-mat-file-upload';
import {HttpApiService} from '../../shared/services/http-api.service';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})

export class UserProfileComponent implements OnInit, OnDestroy {

    public loading = false;
    public userForm: FormGroup;
    public companyForm: FormGroup;
    public userProfile: UserProfileModel;

    @ViewChild(MatSort, {static: true}) sort: MatSort;
    public entityType: string = null;
    public selectedFile: any = null;
    public cvLinkList: Array<any> = [];

    constructor(
        private _formBuilder: FormBuilder,
        private userService: UserService,
        private validationMessageService: ValidationMessageService,
        private toastr: ToastrService,
        private httpApiService: HttpApiService,
    ){

    }


    ngOnInit(): void
    {


        // Reactive Form
        this.userForm = this._formBuilder.group({

            name : ['', Validators.required ],
            email   : [{ value: '', disabled: true}, Validators.required],
            password  : [''],
            password_confirmation   : ['', confirmPasswordValidator],
        });

        this.companyForm = this._formBuilder.group({
            name : ['', (this.entityType !== 'student') ?  Validators.required : null],
            uniqueRegistrationCode : ['', (this.entityType !== 'student') ?  Validators.required : null],
            nrRegCom : ['', (this.entityType !== 'student') ?  Validators.required : null],
        });

        this.getProfile();

    }

    getProfile(): void {
        this.loading = true;
        this.userService.getUserProfile()
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: ApiResponseModel) => {

                const user: UserModel = new UserModel().map(response.payload.user);
                const company: CompanyModel = new CompanyModel().map(response.payload.company);

                this.userProfile = response.payload;
                this.entityType = user.entityType;
                this.getCvLink();

                this.companyForm.patchValue({
                    name : company.name,
                    uniqueRegistrationCode : company.uniqueRegistrationCode,
                    nrRegCom : company.nrRegCom,
                });
                this.userForm.patchValue({
                    name: user.name,
                    email: user.email,
                    password: null,
                    password_confirmation: null,
                });

            });
    }


    ngOnDestroy(): void
    {

    }

    onSaveProfile(): void
    {

        this.loading = true;

        const userProfileModel: UserProfileModel = new UserProfileModel();

        userProfileModel.user = new UserModel().map(this.userForm.getRawValue());
        userProfileModel.user.entityType = this.entityType;
        userProfileModel.company = new CompanyModel().map(this.companyForm.getRawValue());


        this.userService.updateUserProfile(userProfileModel)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: ApiResponseModel) => {
                this.userProfile = response.payload;
                this.sendImage();
            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.userForm, 'user.' , false);
                    this.validationMessageService.serverSideValidation(err, this.companyForm, 'company.',  false);
                }
            });

    }

    public onFileChange(files: MatFileUploadComponent): void {
        this.selectedFile = files;
    }

    public sendImage(): void {

        this.loading = true;
        this.httpApiService.postFile(this.selectedFile.value[0], 'User', 'cv', this.userProfile.user.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe(() => {
                this.getCvLink();
                this.toastr.success('Succes!', 'Datele au fost salvate cu succes!');
            });
    }

    public getMediaDetails(): any
    {
        const media = this.cvLinkList[this.cvLinkList.length - 1];

        return {
            name: media.name,
            url: media.url,
        };
    }

    public getCvLink(): void
    {
        this.loading = true;
        this.httpApiService.getFile('User', 'cv', this.userProfile.user.uid, false)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: ApiResponseModel) => {
                this.cvLinkList = response.payload;
            });
    }

    public onDownloadCV(): void {
        console.log(this.getMediaDetails());
        window.open(
            this.getMediaDetails().url,
            '_blank' // <- This is what makes it open in a new window.
        );
    }
}

